export default "__VITE_ASSET__DaePFM3n__"